export default __webpack_public_path__ + "static/media/funda.cbf6a081.jpg";